export default __webpack_public_path__ + "static/media/item-environment.13dce021.jpg";